import { useState } from 'react';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { BackrsIcon } from './BackrsIcon';
import { appStrings } from '../assets/appStrings';

const TOUR_STRINGS = appStrings.modules.tour;

type HideTourExpandableButtonProps = Readonly<{
  onHideTourClick: () => void;
  onShowTourClick: () => void;
  isTourActive: boolean;
  containerSx?: SxProps<Theme>;
}>;
export const HideTourExpandableButton = ({
  onHideTourClick,
  isTourActive,
  onShowTourClick,
  containerSx,
}: HideTourExpandableButtonProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      onClick={isExpanded ? undefined : () => setIsExpanded((prev) => !prev)}
      sx={
        {
          ...containerStyle,
          borderRadius: isExpanded ? '24px' : '100%',
          cursor: isExpanded ? 'default' : 'pointer',
          ...containerSx,
        } as SxProps<Theme>
      }
      id="hide-tour-expandable-button"
    >
      <BackrsIcon
        name="IconBusOff"
        alt={isTourActive ? TOUR_STRINGS.leaveTour : TOUR_STRINGS.showTour}
        height={24}
        width={24}
      />
      {isExpanded && (
        <>
          <Typography
            sx={textStyles}
            onClick={() => {
              setIsExpanded(false);

              if (isTourActive) {
                onHideTourClick();

                return;
              }

              onShowTourClick();
            }}
          >
            {isTourActive ? TOUR_STRINGS.leaveTour : TOUR_STRINGS.showTour}
          </Typography>
          <Box onClick={() => setIsExpanded(false)} sx={closeIconStyle}>
            <BackrsIcon name="IconClose" alt="close" height={20} width={20} />
          </Box>
        </>
      )}
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  position: 'fixed',
  right: '16px',
  top: '16px',
  bgcolor: 'black',
  zIndex: 100000000000,
  display: 'flex',
  justifyContent: 'space-between',
  gap: 2,
  alignItems: 'center',
  padding: '12px',
} as const;

const closeIconStyle: SxProps<Theme> = {
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as const;

const textStyles: SxProps<Theme> = {
  cursor: 'pointer',
  color: 'white',
  fontSize: '1rem',
  fontWeight: 'bold',
  lineHeight: 1,
} as const;
